// ============================================================================
// Session State - Client-side session persistence
// ============================================================================

const SESSION_STORAGE_KEY = 'dreamgame_session_id';

// Generate a UUID v4 for new sessions
const generateSessionId = (): string => {
  return crypto.randomUUID();
};

// Get or create session ID from localStorage
const initializeSessionId = (): string => {
  const stored = localStorage.getItem(SESSION_STORAGE_KEY);
  if (stored) {
    return stored;
  }

  const newSessionId = generateSessionId();
  localStorage.setItem(SESSION_STORAGE_KEY, newSessionId);
  return newSessionId;
};

// Cache the session ID after initialization
const sessionId = initializeSessionId();

// ============================================================================
// Public API
// ============================================================================

export const getSessionId = (): string => {
  return sessionId;
};

export const clearSession = (): void => {
  localStorage.removeItem(SESSION_STORAGE_KEY);
};
